import styled from "styled-components";

export const Content = styled.span`
  visibility: hidden;
  position: absolute;
  min-width: 100px;
  width: fit-content;
  height: min-content;
  transition: all ease 0.2s;
  padding: 5px;
  top: 100%;
  bottom: 20%;
  left: 50%;
  right: 50%;
  z-index: 99;
  color: ${({ color }) => color};
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 5px;
  font-size: 0.8rem;
  font-style: ${({ fontStyle }) => fontStyle};
`;

export const Container = styled.span`
  display: inline-block;
  width: 100%;

  div {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: ${({ direction }) => direction};
    align-items: center;
    width: min-content;
    height: min-content;
  }

  div:first-child {
    cursor: pointer;
  }

  div:first-child:hover ${Content} {
    visibility: visible;
  }
`;
